/**
 * El boton de «agregar al carrito» de la grilla, en chico.
 *
 * 🔴 POR QUE NO VA EL BOTON DE ANCHO COMPLETO. Dawn lo pone abajo del precio,
 *    52px de alto y todo el ancho de la tarjeta. Con 8 productos en pantalla
 *    son OCHO botones gritando lo mismo, y cada uno le gana en peso visual a la
 *    foto del producto —que es lo que de verdad vende—. Damian lo dijo asi:
 *    «no te parece super agresivo el boton asi de grande». Tiene razon: la
 *    regla es UN llamado principal por pantalla, no uno por tarjeta.
 *
 * 🔴 DONDE VA: EN LA FRANJA DE PRECIO, AL OTRO EXTREMO. Primero lo puse sobre
 *    la foto, en espejo con el corazon. Damian: «el boton de agregar al carrito
 *    no esta claro». Tenia razon — encima de una foto de una modelo, un circulo
 *    blanco con un dibujo chico compite con la imagen y no se lee como un
 *    boton. En la franja rosa, al otro extremo del precio, esta donde la clienta
 *    ya esta mirando para decidir, y no tapa nada.
 *
 * 🔴 SIEMPRE VISIBLE, NO AL PASAR EL MOUSE. En el celular no hay hover. Un
 *    boton que solo aparece con el puntero no existe para mas de la mitad del
 *    trafico, que es justo la mitad que compra desde el telefono.
 *
 * 🔴 Y ADEMAS ASI SE ARREGLA SOLO EL PROBLEMA DEL CLIC. Sobre la foto habia que
 *    pelear con `.full-unstyled-link::after`, el enlace que Dawn estira sobre
 *    toda la tarjeta: los contenedores de la imagen abren contexto de apilado
 *    —`.card__media` con `z-index: 0`, `.card__inner` con un `transform` que no
 *    se ve hasta que lo medis— y el boton quedaba debajo por mas z-index que le
 *    pusieras. Habia que subir la foto y darle `pointer-events: none`. En la
 *    franja de precio no hace falta nada de eso: el bloque del precio viene
 *    DESPUES del enlace en el DOM, asi que con `position: relative` ya le gana.
 *
 * 🔴 Y ADEMAS, AL PASAR EL MOUSE, UNA BARRA SOBRE LA FOTO. Damian la vio en
 *    Indie y la pidio «sin quitar el otro»: son dos puertas a la misma accion.
 *    La bolsita de la franja es la que vale siempre —y la unica en el telefono,
 *    donde no hay mouse—; la barra es un atajo de escritorio.
 *
 * 🔴 LA BARRA NO ES OTRO FORMULARIO: le pasa el clic al boton de verdad. Un
 *    segundo <form> con el mismo id de variante duplica ids en la pagina y
 *    obliga a mantener dos caminos que tienen que dar lo mismo. Asi hay una sola
 *    fuente: si manana cambia como se agrega, cambia en un lugar.
 *
 * 🔴 POR ESO VA `aria-hidden` Y FUERA DEL TABULADOR: repite un control que ya
 *    esta. Quien navega con teclado usa el de la franja; anunciar dos botones
 *    identicos por tarjeta es ruido, no accesibilidad.
 *
 * 🔴 SI ESTE JS NO CARGA, la tarjeta queda con el boton grande de Dawn. El CSS
 *    solo pinta lo que este script marco con `data-ama`. Nadie se queda sin
 *    poder comprar porque falle un archivo.
 */
(function () {
  function svgBolsa() {
    return '<svg class="ama-agregar__i" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M5.8 7.8h12.4l-1 12.2H6.8l-1-12.2z"/>' +
      '<path d="M9.2 7.8V6.2a2.8 2.8 0 0 1 5.6 0v1.6"/></svg>';
  }

  function titulo(tarjeta) {
    var t = tarjeta.querySelector('.card__heading, .card-information__text, h3, h2');
    return t ? t.textContent.trim().replace(/\s+/g, ' ').slice(0, 70) : '';
  }

  function achicar(q) {
    if (q.getAttribute('data-ama') === '1') return;
    var tarjeta = q.closest('.card-wrapper') || q.closest('.card');
    if (!tarjeta) return;
    // el bloque que tiene el precio: ahi adentro va, al otro extremo
    var franja = tarjeta.querySelector('.card-information');
    if (!franja) return;

    var boton = q.querySelector('button');
    if (boton) {
      // 🔴 El nombre accesible sale del `aria-label`, no del texto: el texto lo
      //    esconde el CSS. Sin esto, un lector de pantalla anuncia «boton» a
      //    secas ocho veces seguidas y no se sabe de que producto es cada uno.
      var accion = (boton.innerText || '').trim().replace(/\s+/g, ' ') || 'Agregar al carrito';
      var n = titulo(tarjeta);
      boton.setAttribute('aria-label', n ? accion + ': ' + n : accion);
      boton.setAttribute('title', n ? accion + ': ' + n : accion);
      // 🔴 EL TEXTO SUELTO TAMBIEN HAY QUE ENVOLVERLO. El boton de «agregar al
      //    carrito» trae su texto adentro de un <span> y el CSS lo esconde; el
      //    de «Seleccionar opciones» —el de los productos con variantes, como el
      //    vino— lo trae como NODO DE TEXTO pelado. Ahi la regla no agarraba, el
      //    texto quedaba adentro de un boton de 44px y lo desbordaba 35: 7px de
      //    scroll horizontal en la pagina del vino, a 390. No se ve mirando; lo
      //    encontro revisar-tipografia.mjs y despues hubo que apagar elemento
      //    por elemento para dar con el.
      [].slice.call(boton.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && n.nodeValue && n.nodeValue.trim()) {
          var w = document.createElement('span');
          w.textContent = n.nodeValue;
          boton.replaceChild(w, n);
        }
      });
      if (!boton.querySelector('.ama-agregar__i')) boton.insertAdjacentHTML('afterbegin', svgBolsa());
      ponerBarra(tarjeta, boton);
    }

    q.setAttribute('data-ama', '1');
    franja.appendChild(q);
  }

  // 🔴 LA BARRA VA ADENTRO DE `.card__inner`, y eso trae de vuelta la pelea con
  //    el enlace que Dawn estira sobre toda la tarjeta: `.card__media` abre
  //    contexto de apilado con su `z-index: 0` y `.card__inner` con un
  //    `transform` invisible. El CSS lo resuelve como la primera vez —la foto
  //    sube a z-index 2 y deja pasar los clics, la barra los recibe— pero SOLO
  //    en escritorio, para no tocar nada de como funciona en el telefono.
  function ponerBarra(tarjeta, boton) {
    var inner = tarjeta.querySelector('.card__inner');
    if (!inner || inner.querySelector('.ama-barra')) return;
    if (boton.disabled) return;               // agotado: no se ofrece
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ama-barra';
    b.setAttribute('aria-hidden', 'true');
    b.setAttribute('tabindex', '-1');
    // 🔴 EL TEXTO NO ES `boton.textContent`. Adentro del boton vive tambien el
    //    «Agotado» escondido que Dawn deja listo por si se acaba el stock: la
    //    barra salio diciendo «AGREGAR AL CARRITO AGOTADO». Se toma el primer
    //    <span> que no sea el de agotado ni el que solo lee el lector.
    var etiqueta = '';
    [].slice.call(boton.querySelectorAll('span')).some(function (x) {
      if (x.classList.contains('sold-out-message')) return false;
      if (x.classList.contains('visually-hidden')) return false;
      var t = (x.textContent || '').trim();
      if (!t) return false;
      etiqueta = t; return true;
    });
    b.innerHTML = svgBolsa() + '<span>' + (etiqueta || 'Agregar al carrito') + '</span>';
    b.addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      boton.click();
    });
    inner.appendChild(b);
    inner.classList.add('ama-inner');
  }

  // 🔴 LOS AGOTADOS NO SE MUESTRAN EN LA GRILLA. Damian: «que no se muestren
  //    productos agotados a no ser que tengan la reserva activada».
  //    La senal no la inventamos: es el propio boton de Dawn, que sale
  //    `disabled` SOLO cuando el producto no se puede comprar. Eso deja afuera
  //    exactamente el caso que el pidio preservar: el vino no lleva control de
  //    stock, asi que su boton nunca se deshabilita y la tarjeta se sigue viendo.
  //    Leer el stock por otro lado —una etiqueta, un color de badge— seria
  //    adivinar lo que el tema ya sabe.
  //
  // 🔴 SE ESCONDE EL `.grid__item`, NO LA TARJETA. Escondiendo `.card-wrapper`
  //    el hueco de la grilla queda igual y la fila sale con un vacio.
  //
  // 🔴 LA FICHA SIGUE EN PIE. Solo desaparece del listado: un enlace viejo, un
  //    anuncio o un resultado de Google siguen llegando a la pagina, que dice
  //    «Agotado» como corresponde.
  function esconderAgotados() {
    document.querySelectorAll('.quick-add__submit[disabled]').forEach(function (b) {
      var t = b.closest('.grid__item') || b.closest('.card-wrapper');
      if (t) t.setAttribute('data-ama-agotado', '1');
    });
  }

  function barrer() {
    document.querySelectorAll('.quick-add').forEach(achicar);
    esconderAgotados();
  }

  function iniciar() {
    barrer();
    // 🔴 La grilla se repinta al filtrar y al paginar: sin esto los botones
    //    vuelven al tamano grande despues del primer filtro.
    new MutationObserver(function () { barrer(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
